import { Navigate, Route, Routes } from 'react-router-dom'
import { Shell } from './components/layout/Shell'
import { XPosts } from './pages/XPosts'
import { Legal } from './pages/Legal'
import { Methodology } from './pages/Methodology'
import { NotFound } from './pages/NotFound'
import { Overview } from './pages/Overview'
import { Portfolio } from './pages/Portfolio'
import { Signals } from './pages/Signals'
import { Trades } from './pages/Trades'

export function App() {
  return (
    <Routes>
      <Route element={<Shell />}>
        <Route index element={<Overview />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/signals" element={<Signals />} />
        <Route path="/trades" element={<Trades />} />
        <Route path="/methodology" element={<Methodology />} />
        <Route path="/legal" element={<Legal />} />
        <Route path="/posts" element={<XPosts />} />
        {/* Old admin route parks on the posts page until agent-management UX ships. */}
        <Route path="/admin" element={<Navigate to="/posts" replace />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  )
}
